module.exports = __webpack_public_path__ + "img/gfAR.ddb187ba.png";